import clsx from 'clsx';
import { PropsWithChildren } from 'react';
import { Heading } from 'react-aria-components';
import IconButton from '~/components/buttons/NewIconButton';
import useDataTestId from '~/hooks/useDataTestId';
import IconArrowLeft from '~/icons/icon-arrow-left.svg?react';
import IconClose from '~/icons/icon-close.svg?react';
import styles from './Modal.module.scss';

interface Props {
  Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  onBackClick?: () => void;
  onCloseClick?: () => void;
  dataTestId?: string;
  className?: string;
}

const CloseModalButton: React.FC<{ onClick: () => void; dataTestId?: string }> = ({ onClick, dataTestId }) => {
  return <IconButton onClick={onClick} Icon={IconClose} variant="ghost" data-testid={dataTestId} />;
};

const ModalTitle: React.FC<PropsWithChildren<Props>> = ({
  children,
  Icon,
  onBackClick,
  onCloseClick,
  dataTestId,
  className,
}) => {
  const dt = useDataTestId(dataTestId);
  return (
    <Heading slot="title" className={clsx(styles.title, className)} data-testid={dt()}>
      {onBackClick ? (
        <IconButton onClick={onBackClick} Icon={IconArrowLeft} variant="ghost" data-testid={dt('backButton')} />
      ) : null}
      {Icon && <Icon className={styles.icon} />}
      <div className={styles.titleChildren}>{children}</div>
      {onCloseClick ? <CloseModalButton dataTestId={dt('closeButton')} onClick={onCloseClick} /> : null}
    </Heading>
  );
};

export default ModalTitle;
